<template>
  <div>
    <md-dialog-alert
      :md-active.sync="loginError.exists"
      :md-content="loginError.text"
      md-confirm-text="Aceptar" />

    <form novalidate class="md-layout" @submit.prevent="doLogin">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <md-card-header>
          <div class="md-title">Ingreso</div>
        </md-card-header>

        <md-card-content>
            <md-field>
                <label>Usuario</label>
                <md-input v-model="user.username"></md-input>
            </md-field>

            <md-field :md-toggle-password="false">
                <label>Clave</label>
                <md-input v-model="user.password" type="password"></md-input>
            </md-field>
        </md-card-content>

        <md-card-actions>
          <md-button type="submit" class="md-primary">Conectarse</md-button>
        </md-card-actions>

        <md-card-actions>
          <md-button type="button" class="md-accent" @click="forgotPassword">Olvidé mi clave...</md-button>
        </md-card-actions>
      </md-card>

    </form>
  </div>
</template>

<script>
import firebase from 'firebase';
import {user} from '../helpers/user';

export default {
    name: 'auth',
    data: () => ({
        loginError: {
            exists: false,
            text: ''
        },
        user: {
            username: '',
            password: ''
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.$router.push('/dashboard')
                console.log('User logged in, send to main screen...');
            } else {
                console.log('User not logged in! Show login form...');
            }
        });
    },
    methods: {
        doLogin: function() {
            var loginError = this.loginError;

            if (this.user.username == '' || this.user.password == '') {
                loginError.exists = true;
                loginError.text = 'Ingrese usuario y clave.';
                return;
            } else {
                var that = this;
                firebase.auth().signInWithEmailAndPassword(this.user.username, this.user.password)
                .then(function () {
                    firebase.auth().currentUser.getIdToken(false).then(
                        function (token) {
                            user.setToken(token);
                            that.$router.push('/dashboard');
                        }
                    );
                })
                .catch(function(error) {
                    loginError.exists = true;
                    loginError.text = 'Usuario o clave incorrectos.';

                    var errorCode = error.code;
                    var errorMessage = error.message;
                    console.log(error);
                });
            }
        },
        forgotPassword: function() {
            let email = prompt("Ingresa tu email");

            //if (email != '') {
                firebase.auth().sendPasswordResetEmail(email)
                    .then(() => {
                        console.log("Password reset email sent");
                        alert("Se envió un email con instrucciones para refrescar la clave.");
                    })
                    .catch((err) => {
                        console.log("Error sending password reset email: " + err);
                        alert(err);
                    });
            //}

        }


    }
}
</script>


// WEBPACK FOOTER //
// src/components/Auth.vue